<template>
  <header>
    <div>
      <h1>EMAF No 33 Submission Form</h1>
    </div>
    <div>
      <ul v-if="lang === 'en'">
        <li><router-link to="/">Home</router-link></li>
        <li><router-link to="/regulations">Regulations</router-link></li>
        <li><router-link to="/contact">Contact</router-link></li>
      </ul>
      <ul v-if="lang === 'de'">
        <li><router-link to="/">Startseite</router-link></li>
        <li><router-link to="/regulations">Reglement</router-link></li>
        <li><router-link to="/contact">Kontakt</router-link></li>
      </ul>
    </div>
    <div class="lang">
      <span class="lang-toggle" :class="lang === 'en' ? 'active' : ''" v-on:click="setLangEn">EN</span> / <span class="lang-toggle" :class="lang === 'de' ? 'active' : ''" v-on:click="setLangDe">DE</span>
    </div>
  </header>
</template>

<script>
export default {
  name: 'Header',
  methods: {
    setLangEn: function () {
      this.$store.commit('setLanguage', 'en')
    },
    setLangDe: function () {
      this.$store.commit('setLanguage', 'de')
    }
  },
  computed: {
    lang () {
      return this.$store.state.language
    }
  }
}
</script>

<style scoped>
header {
  z-index: 9;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 3rem;
  background: var(--bg);
  -webkit-box-shadow: 0 1px 5px 0 rgba(192,192,192,0.75);
  -moz-box-shadow: 0 1px 5px 0 rgba(192,192,192,0.75);
  box-shadow: 0 1px 5px 0 rgba(192,192,192,0.75);
  padding: 1rem;
}

h1 {
  font-size: 0.9rem;
  font-weight: bold;
  padding: 0;
  margin: 0;
}

ul {
  display: inline-block;
  list-style: none;
}

li {
  display: inline-block;
  padding: 0 0.5rem;
}

a {
  text-decoration: none;
}

.router-link-exact-active,
.langtoggle .active {
  color: var(--acc);
}

.lang,
span {
  font-size: 0.9rem;
}

.lang-toggle:hover {
  cursor: pointer;
  color: var(--acc);
}
</style>
